import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import NumberOfRecordsFound from '../../../../sharedmodules/components/number-of-records-found';
import PropTypes from 'prop-types';
import ReportGrid from '../../../../sharedmodules/components/report-grid/index';
import ReportHeader from '../../../../sharedmodules/components/report-header/report-header';
// import UserAccountMapping from './user-account-mapping';
import { getUserDealerColumnDefinitions } from '../../services/column-definations';

const UserDealerMapping = (props) => {

    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridApi, setGridApi] = useState(null);
    const [showSelectAll, setShowSelectAll] = useState(true);

    const onGridReady = (params) => {

        setGridApi(params.api);
        setGridColumnApi(params.columnApi);

    };

    const handleSelectDeselectAll = () => {

        showSelectAll ? gridApi.selectAllFiltered() : gridApi.deselectAllFiltered();
        setShowSelectAll(!showSelectAll);

    };

    return (
        props.userDealerMappedData[0].userId && (
            <div>
                <NumberOfRecordsFound count={props.userDealerMappedData.length} />
                <section className="dealer-settings-panel">
                    <section className="report">
                        <ReportHeader
                            columnApi={gridColumnApi}
                            gridApi={gridApi}
                            reportName="credit-memo"
                            showExport={false}
                        >
                            <div className="display-credit-memo-button">
                                <button type="button" onClick={handleSelectDeselectAll}>
                                    {showSelectAll ?
                                        <FormattedMessage id="SELECT_ALL" /> :
                                        <FormattedMessage id="DESELECT_ALL" />
                                    }
                                </button>

                            </div>
                        </ReportHeader>
                        <ReportGrid
                            columnDefs={getUserDealerColumnDefinitions()}
                            onGridReady={onGridReady}
                            onRowSelected={() => ''}
                            rowData={props.userDealerMappedData}
                            rowDeselection
                            rowSelection="multiple"
                        />
                    </section>
                    {/* <UserAccountMapping /> */}
                </section>
            </div>
        )
    );

};

UserDealerMapping.propTypes = {
    userDealerMappedData: PropTypes.array,
};

export default UserDealerMapping;
